var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExport = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-external-link",
  "data-name": "Icon feather-external-link",
  transform: "translate(-2.999 -2.999)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Union_8",
  "data-name": "Union 8",
  d: "M2.4,16A2.4,2.4,0,0,1,0,13.6V4.8A2.4,2.4,0,0,1,2.4,2.4H7.2A.8.8,0,0,1,7.2,4H2.4a.8.8,0,0,0-.8.8v8.8a.8.8,0,0,0,.8.8h8.8a.8.8,0,0,0,.8-.8V8.8a.8.8,0,1,1,1.6,0v4.8A2.4,2.4,0,0,1,11.2,16Zm3.436-5.834a.8.8,0,0,1,0-1.131L13.269,1.6H10.4a.8.8,0,0,1,0-1.6h4.8a.8.8,0,0,1,.743.5h0s0,.01.006.014v0s0,.009.006.013,0,0,0,.007a.027.027,0,0,1,0,.01.035.035,0,0,0,0,.01.016.016,0,0,0,0,.007.041.041,0,0,0,0,.013s0,0,0,0,0,.01,0,.016h0A.86.86,0,0,1,16,.824V5.6a.8.8,0,1,1-1.6,0V2.731L6.966,10.166A.8.8,0,0,1,6.4,10.4.794.794,0,0,1,5.836,10.166Z",
  transform: "translate(2.999 2.999)",
  fill: "currentColor"
}))));
export { SvgExport as ReactComponent };
export default __webpack_public_path__ + "static/media/export.516f5457d07915a9269de074b1868cf9.svg";